module.exports = __webpack_public_path__ + "files/9c78deb4014b12028f511ee812b65b05.png";